<template>
<div>
  <section v-if="!isMobile" class="portfolio-section">
    <div class="an1">
      <img src="../../../assets/img/cloud.png" alt="sky">
    </div>
    <div class="an2">
      <img src="../../../assets/img/an1.png" alt="sky">
    </div>
    <div class="hGround"></div>
    <div class="hLeftTr"></div>
    <div class="hRigthTr"></div>
    <div class="ilAnim"></div>
    <b-container>
      <b-row>
        <b-col sm="7" md="7" lg="7">
        <div class="homeLt">
          <div class="animationFlWr">
            <div class="ltBl"></div>
            <div class="fl1"><img src="../../../assets/img/fl-1.gif" alt="animation"></div>
            <div class="fl2"><img src="../../../assets/img/fl-1.gif" alt="animation"></div>
          </div>
        </div>
        </b-col>
        <b-col sm="5" md="5" lg="5">
          <div class="banner-content-block">
            <div class="char-box"><img src="../../../assets/img/char.png" alt="char"></div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
  <div v-else>
    <section class="portfolio-section-mobile">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="12">
            <div class=mobile-banner-content>
              <div class="house-container">
                <img src="@/assets/img/homeLt.png" alt="Independent game studio">
              </div>
              <div class="char-container">
                <img src="@/assets/img/char.png" alt="Independent game studio">
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div class="bottom-box"></div>
    </section>
    <section class="banner-text-container-mobile">
      <b-container>
        <b-row>
          <b-col sm="12" md="12" lg="12">
          </b-col>
      </b-row>
    </b-container>
    </section>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      isMobile: false
    }
  },
  mounted () {
    this.isMobile = this.$isMobile()
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
.portfolio-section{
    width: 100%;
    min-height: 922px;
    position: relative;
    background: url('../../../assets/img/Nebula-text.svg')  no-repeat top 74px center/800px,
            url('../../../assets/img/header-l1.jpg') top center / cover;
    overflow: hidden;
    @media screen and (max-width: 991px){
        display:none;
    }
     @media screen and (min-width: 1025px){
        background: url('../../../assets/img/Nebula-text.svg')  no-repeat top 60px center/800px,
            url('../../../assets/img/header-l1.jpg') top center / cover;
    }
    @media screen and (min-width: 1920px){
        min-height: 899px;
        background: url('../../../assets/img/Nebula-text.svg')  no-repeat top 74px center/800px,
            url('../../../assets/img/header-l1.jpg') top center / cover;
    }
  .hGround{
      width: 100%;
      height: 256px;
      position: absolute;
      bottom: -1px;
      left: 0;
      z-index: 5;
      background: url('../../../assets/img/hGround.png') bottom center no-repeat;
      background-size: cover;
      @media screen and (min-width: 1920px){
        background: linear-gradient(to top, #2D2412, #6B5F3E);
        background: url('../../../assets/img/hGround2.png');
        height: 114px;
      }
    }
  .hLeftTr{
    width: 358px;
    height: 865px;
    position: absolute;
    z-index: 3;
    bottom: 130px;
    left: 0;
    background: url('../../../assets/img/hTr.png');
    @media screen and (min-width: 1920px){
        bottom: 92px;
    }
  }
  .hRigthTr{
    width: 582px;
    height: 320px;
    position: absolute;
    z-index: 3;
    bottom: 113px;
    right: 0;
    opacity: 0.7;
    background: url('../../../assets/img/hTrR.png');
     @media screen and (min-width: 1920px){
        bottom: 93px;
    }
  }
  .ilAnim {
      width: 100%;
      height: 219px;
      position: absolute;
      top: 333px;
      left: 0;
      z-index: 1;
      opacity: 0.2;
      background: url('../../../assets/img/ilAmin.png');
      animation-name: MOVE-BG;
      animation-duration: 180s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
  }
  .an1 {
    width: 179px;
    height: 56px;
    position: absolute;
    top: 300px;
    left: 0;
    z-index: 2;
    animation: hAnim1 60s linear infinite;
    img{
      width: 100%;
    }
  }
  .an2 {
      width: 179px;
      height: 56px;
      position: absolute;
      top: 400px;
      right: 0;
      z-index: 2;
      opacity: 0.5;
      transform: rotateY(180deg);
      animation: hAnim2 65s linear infinite;
  }

  .homeLt {
      width: 829px;
      height: 724px;
      margin: 0 auto;
      position: relative;
      top: 87px;
      z-index: 4;
      background: url('../../../assets/img/homeLt.png');
      .animationFlWr {
        position: absolute;
        right: 52px;
        top: 48px;
        width: 200px;
        height: 200px;
        @media screen and (max-width: 1024px){
        .animationFlWr {
            display: none;
        }
      }
        .ltBl {
            width: 100px;
            height: 100px;
            position: absolute;
            top: 64px;
            left: 42px;
            border-radius: 100%;
            box-shadow: 0 0 50px 0 rgba(224, 165, 105, 0.7), 0 0 10px 0 rgba(255, 255, 255, 0.7) inset;
            animation: hAnim3 3s infinite;
        }
    }
      .fl1 {
          border-radius: 20px;
          box-shadow: 0 0 10px rgba(233, 239, 159, 0.99), 0 0 8px rgba(233, 239, 159, 0.6) inset;
      }
      .fl1 {
        width: 9px;
        height: 11px;
        position: absolute;
        top: 46px;
        left: 16px;
        transform-origin: 0 0;
        animation: flAnim 1.5s ease infinite;
        img{
          position: relative;
          top: -8px;
        }
    }
      .fl2 {
        border-radius: 20px;
        box-shadow: 0 0 10px rgba(233, 239, 159, 0.99), 0 0 8px rgba(233, 239, 159, 0.6) inset;
      }
      .fl2 {
        width: 9px;
        height: 11px;
        position: absolute;
        top: 180px;
        right: 36px;
        transform-origin: 0 0;
        animation: flAnim2 1.8s ease infinite;
        img {
            top: -8px;
            left: 1px;
            position: relative;
        }
    }
  }
  .banner-content-block {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    text-align: left;
    min-height: 822px;
    position:relative;
   @media screen and (max-width: 991px){
        height: auto;
        min-height: auto;
    }
    p{
      color: #FFF;
      font-family: $main-font;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height:  36px;
      margin: 165px 0 0 12px;

      @media screen and (min-width: 992px) {
          font-size: 16px;
          line-height: 24px;
          margin: 165px 0 0 120px;
          z-index: 9;
      }
      @media screen and (min-width: 1440px) {
        font-size: 18px;
        line-height: 30px;
        margin: 165px 0 0 76px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
        line-height:  36px;
        margin: 165px 0 0 12px;
      }
    }
    .char-box{
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
    }
  }
}

@keyframes MOVE-BG {
  0% {
    background-position: 0% 0%;
  }
  100% {
      background-position: 187% 0%;
  }
}

@keyframes hAnim1 {
  0% {
    left: 0;
    opacity: 0;
  }
  10% {
      opacity: 1;
  }
  80% {
      opacity: 1;
  }
  90% {
      opacity: 0;
  }
  100% {
      opacity: 0;
      left: 2000px;
  }
}

@keyframes hAnim2{
  0% {
    right: 0;
    opacity: 0;
  }
  10% {
      opacity: 1;
  }
  80% {
      opacity: 1;
  }
  90% {
      opacity: 0;
  }
  100% {
      opacity: 0;
      right: 2000px;
  }
}
@keyframes flAnim{
  0% {
      transform: translate(0, 0);
  }
  50% {
      transform: translate(0, 8px);
  }
  100% {
      transform: translate(0, 0);
  }
}
@keyframes flAnim2{
  0% {
    transform: translate(0, 0) rotate(-140deg);
  }
  50% {
      transform: translate(0, -8px) rotate(-140deg);
  }
  100% {
      transform: translate(0, 0) rotate(-140deg);
  }
}
@keyframes hAnim3{
  0% {
      opacity: 0.01;
  }
  50% {
      opacity: 0.5;
      box-shadow: 0 0 90px 0 rgba(224, 165, 105, 0.7), 0 0 5px 0 rgba(255, 255, 255, 0.3) inset;
  }
  100% {
      opacity: 0.01;
  }
}
.portfolio-section-mobile{
  height: auto;
  min-height: 307px;
  background: url('../../../assets/img/mobile-banner-bg.jpg') center center / cover;
  position: relative;
   @media screen and (min-width: 991px){
        display:none;
    }
  .mobile-banner-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media screen and (min-width: 320px) {
      background:  url('../../../assets/img/Nebula-text.svg')  no-repeat top 35px center/300px;
    }
    @media screen and (min-width: 424px) {
      background:  url('../../../assets/img/Nebula-text.svg')  no-repeat top 15px center/300px;
    }
    @media screen and (min-width: 768px) {
      padding-top: 25px;
      background:  url('../../../assets/img/Nebula-text.svg')  no-repeat top 14px center/400px;
    }
    @media screen and (min-width: 991px) {
      background:  url('../../../assets/img/Nebula-text.svg') no-repeat top 10px left 10%/350px;
    }
    @media screen and (min-width: 1920px) {
    }
    .house-container{
      min-height: 307px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      img{
        width: 100%;
        max-width: 400px;
        min-width: 270px;
        height: auto;
        position: relative;
        top: 5px;
      }
    }
    .char-container{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      img{
        width: 100%;
        min-width: 30px;
        max-width: 50px;
        height: auto;
        position: relative;
        top: 7px;
        z-index: 1;
        @media screen and (min-width: 320px) {
        }
        @media screen and (min-width: 424px) {
          top: 2px;
        }
        @media screen and (min-width: 768px) {
          top: 10px;
        }
        @media screen and (min-width: 992px) {
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
  }
  .bottom-box{
    height: 30px;
    width: 100%;
    background: url('../../../assets/img/hGround2.png') no-repeat bottom center/ 100%;
    position: absolute;
    bottom: -16px;
    left: 0;
    @media screen and (min-width: 320px) {
    }
    @media screen and (min-width: 424px) {

    }
    @media screen and (min-width: 768px) {
      bottom: -27px;
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
}
.banner-text-container-mobile{
  padding: 40px 24px 24px 24px;
  background: #20201E;
  p{
    color: #FFF;
    font-family: $main-font;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
}
</style>
